import { Lens } from "monocle-ts";

export const changeWithLens = <T, TProp extends keyof T>(
  getLens: (key: TProp) => Lens<T, T[TProp]>,
  changeFunction: (value: T) => void,
  existingValue: T
) => (key: TProp) => (newValue: T[TProp]) => {
  changeFunction(getLens(key).set(newValue)(existingValue));
};
